import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Popup } from "react-leaflet";
import { LeafletTrackingMarker } from "react-leaflet-tracking-marker";
import { fetchVehicleData } from "../api/flespiApi";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import truckIcon from "../assets/icons/truck.png";
import carIcon from "../assets/icons/car.png";
import bikeIcon from "../assets/icons/bike.png";
import tricycleIcon from "../assets/icons/tricycle.png";
import "../styles/MapComponent.css"; // ✅ Make sure this exists

const directionOffsets = {
  truck: 360,
  bike: 0,
  tricycle: 0,
  car: 0,
};

const getRotatedDivIcon = (vehicle) => {
  const type = vehicle.vehicleType?.toLowerCase() || "car";
  const offset = directionOffsets[type] || 0;
  const adjustedRotation = ((vehicle.direction || 0) + offset) % 360;
  const iconUrl =
    type === "truck"
      ? truckIcon
      : type === "bike"
      ? bikeIcon
      : type === "tricycle"
      ? tricycleIcon
      : carIcon;

  const isMoving = Number(vehicle.speed) > 0;

  return L.divIcon({
    className: `custom-div-icon ${isMoving ? "vibrating" : ""}`,
    html: `
      <div class="rotating-wrapper" style="transform: rotate(${adjustedRotation}deg);">
        <img src="${iconUrl}" width="40" height="40" />
      </div>`,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
  });
};

const MapComponent = ({ vehicles = [], selectedVehicles = [] }) => {
  const [liveVehicles, setLiveVehicles] = useState([]);

  useEffect(() => {
    const update = async () => {
      const data = await Promise.all(
        vehicles.map(async (vehicle) => {
          const vData = await fetchVehicleData(vehicle.deviceId);
          if (!vData) return null;

          const [lat, lng] = vData.location.split(", ").map(Number);
          return {
            ...vehicle,
            latitude: lat,
            longitude: lng,
            direction: vData.direction || 0,
            speed: vData.speed || 0,
          };
        })
      );
      setLiveVehicles(data.filter(Boolean));
    };

    update();
    const interval = setInterval(update, 30000);
    return () => clearInterval(interval);
  }, [vehicles]);

  const displayVehicles =
    selectedVehicles.length > 0
      ? liveVehicles.filter((v) => selectedVehicles.includes(v.id))
      : liveVehicles;

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <MapContainer center={[6.5244, 3.3792]} zoom={10} style={{ height: "100%", width: "100%" }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

        {displayVehicles.map((v) =>
          v.latitude && v.longitude ? (
            <LeafletTrackingMarker
              key={v.id}
              position={[v.latitude, v.longitude]}
              previousPosition={[v.latitude, v.longitude]}
              duration={30000}
              icon={getRotatedDivIcon(v)}
            >
              <Popup>
                <strong>{v.plateNumber || "Unknown"}</strong><br />
                Type: {v.vehicleType}<br />
                Speed: {v.speed} km/h<br />
                Location: {v.latitude}, {v.longitude}
              </Popup>
            </LeafletTrackingMarker>
          ) : null
        )}
      </MapContainer>
    </div>
  );
};

export default MapComponent;
